import { IMAGE_ACTION_TYPE } from 'redhotpie-shared-lib/constants/constants';
import { IMainPhoto } from 'redhotpie-shared-lib/interfaces/IUser';

export interface IPhotoData {
  FullUrl: string;
  Height: number | null;
  IsPublic: boolean;
  IsUserImage: boolean;
  PhotoID: number | null;
  ThumbUrl: string;
  Width: number | null;
  ImageType: string;
  ImageActionType: string;
  ShowSafeMode: boolean;
  Classification: number;
  IsMain?: boolean;
  IsAccepted?: boolean;
  GalleryID?: number;
  PrivateGalleryOnly?: boolean;
  IsLiked?: boolean;
  MainPhoto?: boolean;
  ApprovalStatus?: string;
  MemberLikeCount?: number;
}

export default class Photo {
  photoId: number | null;
  thumbUrl: string;
  fullUrl: string;
  height: number | null;
  width: number | null;
  isPublic: boolean;
  classification: number;
  imageType: string;
  imageActionType: string;
  showSafeMode: boolean;
  isMain: boolean;
  isAccepted: boolean;
  galleryId: number;
  isUserImage: boolean;
  privateGalleryOnly: boolean;
  mainPhoto: boolean;
  approvalStatus: string;
  isLiked: boolean;
  memberLikeCount: number;

  constructor() {
    this.photoId = 0;
    this.thumbUrl = '';
    this.fullUrl = '';
    this.height = 0;
    this.width = 0;
    this.isPublic = false;
    this.classification = 0;
    this.imageType = '';
    this.imageActionType = '';
    this.showSafeMode = false;
    this.isMain = false;
    this.isAccepted = false;
    this.galleryId = 0;
    this.isUserImage = false;
    this.privateGalleryOnly = false;
    this.mainPhoto = false;
    this.approvalStatus = 'Pending';
    this.isLiked = false;
    this.memberLikeCount = 0;
  }

  static mappingObject(_photo: IPhotoData): IMainPhoto {
    const photo = Object.assign(new Photo(), _photo);
    photo.photoId = _photo.PhotoID;
    photo.thumbUrl = _photo.ThumbUrl;
    photo.fullUrl = _photo.FullUrl;
    photo.height = _photo.Height;
    photo.width = _photo.Width;
    photo.isPublic = _photo.IsPublic;
    photo.isUserImage = _photo.IsUserImage || false;
    photo.imageType = _photo.ImageType;
    photo.imageActionType = _photo.ImageActionType || IMAGE_ACTION_TYPE.SHOW_IMAGE;
    photo.showSafeMode = _photo.ShowSafeMode || false;
    photo.galleryId = _photo.GalleryID || 0;
    photo.classification = _photo.Classification;
    photo.isMain = _photo.IsMain || false;
    photo.isAccepted = _photo.IsPublic ? true : _photo.IsAccepted || false;
    photo.privateGalleryOnly = _photo.PrivateGalleryOnly || false;
    photo.mainPhoto = _photo.MainPhoto || false;
    photo.approvalStatus = _photo.ApprovalStatus || 'Pending';
    photo.isLiked = _photo.IsLiked || false;
    photo.memberLikeCount = _photo.MemberLikeCount || 0;
    return photo;
  }

  static mappingObjects(_photos: IPhotoData[]): IMainPhoto[] {
    const photos: IMainPhoto[] = [];
    for (const _photo of _photos) {
      const photo = Photo.mappingObject(_photo);
      photos.push(photo);
    }
    return photos;
  }

  static mappingCustomObject(_photo: IPhotoData): IMainPhoto {
    const photo = new Photo();
    photo.photoId = _photo.PhotoID;
    photo.thumbUrl = _photo.ThumbUrl;
    photo.fullUrl = _photo.FullUrl;
    photo.height = _photo.Height;
    photo.width = _photo.Width;
    photo.isPublic = _photo.IsPublic;
    photo.imageType = _photo.ImageType;
    photo.classification = _photo.Classification;
    photo.imageActionType = _photo.ImageActionType || IMAGE_ACTION_TYPE.SHOW_IMAGE;
    photo.showSafeMode = _photo.ShowSafeMode || false;

    return photo;
  }

  static mappingCustomObjects(_photos: IPhotoData[]): IMainPhoto[] {
    const photos: IMainPhoto[] = [];
    for (const _photo of _photos) {
      const photo = Photo.mappingCustomObject(_photo);
      photos.push(photo);
    }
    return photos;
  }
}
